<template>
  <div id="content">

    <dlnkalert
        :message="message"
        :message_type="message_type"
        @close="closeMessage()"
    ></dlnkalert>

    <img class="img-fluid w-100" src="/modules/dlnkcsam/img/psg.jpg" alt="Visuel de l'évènement">

    <!-- Property Description Section -->
    <div class="container space-bottom-2">
      <div class="row">
        <div class="col-12 mb-9 mb-lg-0 mt-3">
          <div class="d-md-flex justify-content-md-center align-items-md-center">
            <figure class="d-none d-md-block avatar avatar-lg mr-3">
              <img class="avatar-img" src="/themes/template/img/icons/icon-63.svg" alt="SVG">
            </figure>
            Gagner des places pour le match PSG-Clermont-Ferrand
          </div>

          <hr class="my-6">

          <h4 class="mb-4">
            Le centre social André Malraux offre 40 places pour le match PSG - Clermont-Ferrand au Parcs des Princes à
            ses adhérents.
            <br><br>
            Si vous souhaitez participer au tirage au sort, prenez rendez-vous pour votre inscription au CSAM.
            <br><br>
            Pour celà, <strong>cliquer sur un créneau de 15 minutes</strong>.
          </h4>

          <div class="row">
            <div class="col-sm-6 col-md-5">
              <!-- Media -->
              <div class="media">

                <div class="media-body">

                  Plus d'info :
                  <span class="d-block font-size-1 mb-1">
                    <i class="fas fa-phone mr-1"></i>
                      01 43 83 89 58
                  </span>
                </div>
              </div>
              <!-- End Media -->
            </div>
          </div>

          <hr class="my-6">

          <div class="mt-6" id="reservation-calendar">
            <FullCalendar ref="reservationCalendar" :options="calendar_options"/>
          </div>

          <div class="mt-6">
            <p id="reservation-confirmation" class="alert alert-info h4 d-none">
            </p>
          </div>


          <!-- End Row -->
        </div>
      </div>
      <!-- End Row -->

      <!-- Sticky Block End Point -->
      <div id="stickyBlockEndPoint"></div>
    </div>
    <!-- End Property Description Section -->
  </div>
</template>

<script>
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import frLocale from '@fullcalendar/core/locales/fr';

export default {
  components: {
    FullCalendar // make the <FullCalendar> tag available
  },
  props: [
    'customer_id',
    'customer_lastname',
    'customer_firstname',
    'customer_mobile',
    'customer_email',
    'api_url',
  ],
  data: function () {
    const _this = this
    return {
      message: "",
      message_type: "",
      resource: Object,
      query: '',
      company: Object,
      customer: Object,
      method: 'post',
      calendar_options: {
        events: [],
        editable: false,
        navLinks: true,
        timeZone: 'Europe/Paris',
        locale: frLocale,
        initialDate: new Date('2021-09-07T15:00:00'),
        initialView: 'dayGridWeek',
        // headerToolbar: { center: 'dayGridWeek' },
        // headerToolbar: {center: 'dayGridMonth,timeGridWeek,timeGridDay'},
        eventDisplay: 'block',
        // dayMaxEvents: 5,
        plugins: [dayGridPlugin, timeGridPlugin],

        eventClick: function (info) {
          _this.eventClick(info)
        },

      },
    }
  },

  mounted() {
    let _this = this;
    this.get_calendar();
    this.checkAlready();
  },

  methods: {

    checkAlready: async function () {
      const _this = this
      const secure_key = await get_token();
      const url = _this.api_url + '/pre_registrations.json?secure_key=' + secure_key + '&customer_id=' + _this.customer_id

      axios({
        method: 'get',
        url: url,
      })
          .then(function (response) {
            if (response.data.length > 0) {
              const date = response.data[0].date
              document.getElementById('reservation-calendar').remove()
              document.getElementById('reservation-confirmation').innerHTML = 'Votre rendez-vous pour le ' + date + ' est enregistrée'
              document.getElementById('reservation-confirmation').classList.remove('d-none')
            }
          })
          .catch(function (response) {
            alert('Erreur inconnu 1');
          });


    },

    closeMessage: function () {
      this.message = "";
      this.message_type = "";
    },
    get_calendar: async function () {
      const _this = this
      const secure_key = await get_token();
      let calendar = _this.$refs.reservationCalendar.getApi()
      calendar.addEventSource(
          _this.api_url + '/pre_registration_appointments.json?secure_key=' + secure_key + '&customer_id=' + _this.customer_id,
      )
    },


    eventClick: async function (info) {
      info.jsEvent.preventDefault()
      const _this = this
      const secure_key = await get_token();
      const appointmentId = info.event.id

      let url = this.api_url + '/pre_registrations.json';

      url += '?secure_key=' + secure_key;
      url += '&customer_id=' + _this.customer_id

      let formData = new FormData();
      formData.append('pre_registration[name]', _this.customer_lastname)
      formData.append('pre_registration[firstname]', _this.customer_firstname)
      formData.append('pre_registration[phone]', _this.customer_name)
      formData.append('pre_registration[email]', _this.customer_email)
      formData.append('pre_registration[pre_registration_appointment_id]', appointmentId)

      axios({
        method: 'post',
        url: url,
        data: formData,

      })
          .then(function (response) {
            //handle success
            const status = response.data.status
            const date = response.data.date

            if (status) {
              _this.message = "Votre rendez-vous est enregistrée"
              _this.message_type = "alert-success"
              document.getElementById('reservation-calendar').remove()
              document.getElementById('reservation-confirmation').innerHTML = 'Votre rendez-vous pour le ' + date + ' est enregistrée'
              document.getElementById('reservation-confirmation').classList.remove('d-none')
            } else {
              _this.message = response.data.errors;
              _this.message_type = "alert-danger";
            }
          })
          .catch(function (response) {
            alert('Erreur inconnu 2');
          });
    },
  },

}

</script>